<template>
  <div id="dev-header">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item" href="https://www.shapelog.com">
          <img src="@/assets/shapelog-logo.svg">
        </a>

        <a v-on:click="toggleMenu" role="button"
          class="navbar-burger burger"
          v-bind:class="{ 'is-active': menuIsVisible }"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbar">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbar"
        class="navbar-menu"
        v-bind:class="{ 'is-active': menuIsVisible }" >
        <div class="navbar-start">
          <router-link
            class="navbar-item"
            to="/">Main</router-link>

          <!-- <router-link
            class="navbar-item"
            to="/api-docs">API Docs</router-link> -->
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'dev-header',
  data() {
    return {
      menuIsVisible: false,
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.menuIsVisible = false;
    },
    navClick() {
      this.menuIsVisible = false;
    },
    toggleMenu() {
      if (this.menuIsVisible === true) {
        this.menuIsVisible = false;
      } else {
        this.menuIsVisible = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/styles/common.scss';

  .navbar {
    background-color: $shapelog-dark-gray;

    .navbar-brand {
      .navbar-burger {
        &.burger {
          span {
            color: $white;
          }
        }
      }
    }

    .navbar-menu {
      .navbar-start {
        .navbar-item {
          cursor: pointer;
        }

        a.navbar-item {
          color: $white;
        }

        a.navbar-item:hover {
          color: $shapelog-dark-gray;
        }
      }

      &.is-active {
        .navbar-start {
          .navbar-item {

          }

          a.navbar-item {
            color: $shapelog-dark-gray;
          }
        }
      }
    }
  }
</style>
